export const viewportHeight = 'calc(100 * var(--vh,1vh))'
export const viewportHeightConsideringNotch =
  'calc(100 * var(--vh-detect-notch,1vh))'
export const stickToBottomTransform =
  'var(--stick-to-bottom-transform, translateY(0))'
export const stickToTopTransform =
  'var(--stick-to-top-transform, translateY(0))'
export const bottomSafeAreaHeight = 'var(--bottom-safe-area-height)'

export const safeAreaCssVariables = {
  insetBottom: 'var(--safe-area-inset-bottom,0)',
  insetTop: 'var(--safe-area-inset-top,0)',
  insetLeft: 'var(--safe-area-inset-left,0)',
  insetRight: 'var(--safe-area-inset-right,0)',
}

let pendingVhUpdate = false
const VIRTUAL_KEYBOARD_DETECTION_HEIGHT_THRESHOLD = 100

function setProperty(property: string, value: string) {
  window.document.documentElement.style.setProperty(property, value)
}

export const checkIsVirtualKeyboardOpened = () => {
  if (!window.visualViewport) return false
  const visualViewportHeight = window.visualViewport.height
  const documentHeight = window.document.documentElement.offsetHeight
  const heightDiff = documentHeight - visualViewportHeight

  return heightDiff > VIRTUAL_KEYBOARD_DETECTION_HEIGHT_THRESHOLD
}

function viewportHandler() {
  if (pendingVhUpdate) return
  pendingVhUpdate = true

  const isVirtualKeyboardOpened = checkIsVirtualKeyboardOpened()
  requestAnimationFrame(() => {
    pendingVhUpdate = false
    if (!window.visualViewport) {
      setProperty('--vh', `${window.innerHeight / 100}px`)
      setProperty('--stick-to-top-transform', `translateY(0)`)
      setProperty('--stick-to-bottom-transform', `translateY(0)`)
      setProperty('--vh-detect-notch', `${window.innerHeight / 100}px`)
      return
    }

    setProperty('--vh', `${window.visualViewport.height / 100}px`)

    const sab = getComputedStyle(document.documentElement).getPropertyValue(
      '--safe-area-inset-bottom',
    )
    const sat = getComputedStyle(document.documentElement).getPropertyValue(
      '--safe-area-inset-top',
    )

    setProperty(
      '--bottom-safe-area-height',
      isVirtualKeyboardOpened ? '0' : 'var(--safe-area-inset-bottom)',
    )

    setProperty(
      '--vh-detect-notch',
      isVirtualKeyboardOpened
        ? `${(window.visualViewport.height - parseFloat(sat || '0')) / 100}px`
        : `${
            (window.visualViewport.height -
              parseFloat(sab || '0') -
              parseFloat(sat || '0')) /
            100
          }px`,
    )

    // Stick to top
    setProperty(
      '--stick-to-top-transform',
      `translateY(${Math.max(0, window.visualViewport.offsetTop)}px)`,
    )

    // Stick to bottom
    if (window.visualViewport.offsetTop >= 0) {
      setProperty(
        '--stick-to-bottom-transform',
        `translateY(-${Math.max(
          0,
          window.innerHeight -
            window.visualViewport.height -
            window.visualViewport.offsetTop,
        )}px)`,
      )
    }
  })
}

if (window.visualViewport) {
  window.visualViewport.addEventListener('scroll', viewportHandler)
  window.visualViewport.addEventListener('resize', viewportHandler)
}
window.addEventListener('DOMContentLoaded', viewportHandler)
